export default __webpack_public_path__ + "static/media/empty.dbd309de.svg";